/**
 * HTML for @streeva/very-simple-cookie-consent `addBar` (4th argument).
 * British English copy; dialog semantics; no positive tabindex values.
 */
export function buildCookieConsentBarHtml(copy: {
  title: string
  bodyBeforeLink: string
  policyLink: string
  bodyAfterLink: string
}): string {
  return `
<div id="vs-cc" class="vs-cc-bar" role="dialog" aria-modal="true" aria-labelledby="vs-cc-bar-title" aria-describedby="vs-cc-bar-desc">
  <div class="vs-cc-bar__container">
    <div class="vs-cc-bar__notification">
      <div class="vs-cc-bar__text">
        <h2 id="vs-cc-bar-title" class="vs-cc-bar__title">${copy.title}</h2>
        <p id="vs-cc-bar-desc" class="vs-cc-bar__body">
          ${copy.bodyBeforeLink}
          <a id="vs-cc-bar__policy-link" class="vs-cc-bar__link">${copy.policyLink}</a>${copy.bodyAfterLink}
        </p>
      </div>
      <div class="vs-cc-bar__actions">
        <div class="vs-cc-bar__buttons"></div>
      </div>
    </div>
  </div>
</div>
`
}
